import { divide } from 'tio-ui/math';
import programLabelFor from '../../../../../helpers/program-label-for.ts';
import safeFormatNumber from '../../../../../helpers/safe-format-number.ts';
import { t } from 'ember-intl';
import type TasCourseModel from '../../../../../models/tas-course.ts';
import type { TOC } from '@ember/component/template-only';

interface TasProgramCourseCardOverviewTableSig {
  Args: {
    course: TasCourseModel;
  };
  Element: HTMLTableElement;
}

const TasProgramCourseCardOverviewTable: TOC<TasProgramCourseCardOverviewTableSig> = <template>
  <div class="mt-4">
    <h3 class="font-semibold leading-6">
      {{programLabelFor
        "COURSE_DESCRIPTION"
        programTemplate=@course.tasApplication.tasProgramInstance.tasProgramTemplate
      }}

    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{@course.courseDescription}}
    </p>
  </div>

  <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
    <div class="flex justify-between gap-x-4 py-3">
      <dt class="text-gray-500">
        {{programLabelFor
          "COURSE_CREDIT"
          programTemplate=@course.tasApplication.tasProgramInstance.tasProgramTemplate
        }}
      </dt>
      <dd class="flex items-start gap-x-2">
        <div class="font-medium">
          {{@course.courseCredit}}
        </div>
      </dd>
    </div>
    {{#if @course.hasGrades}}
      <div class="flex justify-between gap-x-4 py-3">
        <dt class="text-gray-500">
          {{programLabelFor
            "COURSE_GRADE"
            programTemplate=@course.tasApplication.tasProgramInstance.tasProgramTemplate
          }}
        </dt>
        <dd class="flex items-start gap-x-2">
          <div class="font-medium">
            {{@course.courseGrade}}
          </div>
        </dd>
      </div>
    {{/if}}

    <div class="flex justify-between gap-x-4 py-3">
      <dt class="text-gray-500">
        {{t "tuition_assistance.program_details.courses.course_total"}}
      </dt>
      <dd class="flex items-start gap-x-2">
        <div class="font-medium">
          {{safeFormatNumber (divide @course.courseTotal 100) style="currency" currency="USD"}}
        </div>
      </dd>
    </div>
  </dl>
</template>;

export default TasProgramCourseCardOverviewTable;
